import heroImage from '../assets/hero-campers.jpg';

function Hero() {
  return (
    <div className="relative h-screen">
      {/* Background image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${heroImage})`,
        }}
      />
      
      {/* Content overlay */}
      <div className="relative h-full flex flex-col items-center justify-center text-center text-white px-4">
        <h1 className="text-5xl md:text-6xl font-bold mb-4">
          Furgos Río
        </h1>
        <p className="text-xl md:text-2xl mb-8">
          Camper diem: vive la aventura a tu manera.
        </p>
        <a
          href="https://wa.me/34648728151"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white text-gray-900 px-8 py-3 rounded-md font-medium hover:bg-gray-100 transition-colors"
        >
          Reserva por WhatsApp
        </a>
      </div>
    </div>
  );
}

export default Hero;
